import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { ApplicationEditLayout, Content } from "core/layouts";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { dropletIcon } from "@progress/kendo-svg-icons";

function EmailTemplatesEditTemplate({ emailTemplatesEditViewStore }) {
    const { contentLoading, form, body } = emailTemplatesEditViewStore;

        const styles = `
            body {
                font-family: Calibri, sans-serif !important;
                color: #081420;
            }

            p {
                margin: 0px !important;
                font-size: 11pt;
                white-space: pre-wrap;
            }

            /* v14's ProseMirror editor leaves selection to Chrome's default
               (semi-transparent blue, blends with background colours). v3's editor
               used the opaque system highlight; match it so selecting coloured text
               shows a solid highlight instead of a mixed/blended one. */
            ::selection {
                background-color: highlight;
                color: highlighttext;
            } `

    const onMount = (event) => {
        const iframeDocument = event.dom.ownerDocument;
        const style = iframeDocument.createElement("style");
        style.appendChild(iframeDocument.createTextNode(styles));
        iframeDocument.head.appendChild(style);
    };

    const resize = {
        resize: "vertical",
        overflow: "auto",
    };

    const wordPalette = [
        "#ffffff00",
        "#ffff00",
        "#00ff00",
        "#00ffff",
        "#ff00ff",
        "#0000ff",
        "#FF0000",
        "#ffffff",
    ];

    const CustomBackColor = (props) => (
        <EditorTools.BackColor
            {...props}
            colorPickerProps={{
                // Kendo v14 switched from font-icons to SVG icons; the v3-5 `icon: "background"`
                // + `iconClassName: "k-i-background"` no longer resolve. Left unset, v14's
                // ColorPicker renders a live color-preview swatch that shows the red ".k-no-color"
                // diagonal slash whenever nothing is selected (the default empty state) — looking
                // like a broken icon. Pass the droplet SVG so it shows a static fill glyph,
                // matching the v3-5 `k-i-background` droplet.
                svgIcon: dropletIcon,
                view: "palette",
                paletteSettings: {
                    palette: wordPalette,
                    columns: 4,
                    rows: 2,
                    tileSize: 30,
                },
            }}
        />
    );

    const {
        Bold,
        Italic,
        Underline,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Undo,
        Redo
    } = EditorTools;

    return (
        <ApplicationEditLayout store={emailTemplatesEditViewStore}>
            <Content loading={contentLoading}>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <div className="form__group">
                                        <Editor
                                            style={{
                                                minHeight: 500,
                                                ...resize,
                                            }}
                                            tools={[
                                                [Bold, Italic, Underline],
                                                [
                                                    AlignLeft,
                                                    AlignCenter,
                                                    AlignRight,
                                                    AlignJustify,
                                                ],
                                                [CustomBackColor],
                                                [Undo, Redo]
                                            ]}
                                            contentStyle={{
                                                minHeight: 442,
                                            }}
                                            defaultContent={body}
                                            onMount={onMount}
                                            onChange={(event) => {
                                                let parser =
                                                    new DOMParser();
                                                let doc =
                                                    parser.parseFromString(
                                                        event.html,
                                                        "text/html"
                                                    );
                                                const highlightedSpans =
                                                    Array.from(
                                                        doc.querySelectorAll(
                                                            "span[style*='background-color']"
                                                        )
                                                    );
                                                highlightedSpans.forEach(
                                                    (span) => {
                                                        span.style.display =
                                                            "inline-block";
                                                    }
                                                );
                                                form.$("body").set(doc.body.innerHTML);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    );
}

EmailTemplatesEditTemplate.propTypes = {
    emailTemplatesEditViewStore: PropTypes.object,
};

export default defaultTemplate(EmailTemplatesEditTemplate);

